<template>
    <div class="wrap">
        <Admin v-if="sub_page === 'admin'" :reload_list="reload_list"></Admin>
        <AdminMobile v-if="sub_page === 'mobile'" :reload_list="reload_list"></AdminMobile>
        <ConsultTelMonit v-if="sub_page === 'tmonit'"></ConsultTelMonit>
    </div>
</template>

<script>
    import Admin from '@/components/DrAdmin/Admin.vue'
    import AdminMobile from '@/components/DrAdmin/AdminMobile.vue'
    import ConsultTelMonit from '@/views/ConsultTelMonit.vue'
  export default {
    name: 'dr-admin',
    data () {
      return {
        sub_page: null,
        is_refresh: 0
      }
    },
    methods: {
      set_sub_page () {
        let {sub_page} = this.$route.params
        if (sub_page) {
          this.sub_page = sub_page
        } else {
          this.$router.push('/dr_admin/admin')
        }
      },
      reload_list() {
        // console.log("dradmin reload_list called");
        this.set_sub_page(this.sub_page);
      },
    },
    mounted () {
      // 초기값을 넣어주면 좋겠당
      this.set_sub_page()
    },
    watch: {
      '$route' (to, from) {
        this.set_sub_page()
      }
    },
    components: {Admin, AdminMobile, ConsultTelMonit}
  }
</script>

<style scoped>
    /* Contents
    ------------------------------------------------------- */
    .wrap {
        width: 100%;
        max-width: 1280px;
        margin: 20px auto;
    }
</style>